import { Fragment } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { MissingEntity } from '#components/atoms/missing-entity/MissingEntity.tsx';
import { DetailListRow } from '#components/patterns/detail-list/DetailListRow.tsx';
import { TagLinkWithParens } from '#components/patterns/entity-links/tag-link/TagLinkWithParens.tsx';
import type { TagName } from '#dn-types/host.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { MissingRouteError, useHostRoutes } from '#screens/hosts/hooks/useHostRoutes.ts';

type Props = {
  tagNames: TagName[];
};

/**
 * Look through tags, find any with route subscriptions, and render a DetailListRow with some info about those routes.
 */
export function HostRoutes({ tagNames }: Props) {
  const location = useAppLocation();
  const hostRoutes = useHostRoutes({ tagNames });
  if (!hostRoutes.length) return null;

  return (
    <DetailListRow
      label="Routes"
      value={hostRoutes.map((routeOrErr, idx) => {
        if (routeOrErr instanceof MissingRouteError) {
          return (
            <MissingEntity
              key={routeOrErr.entityId}
              entityId={routeOrErr.entityId}
              tooltipProps={{ render: <span /> }}
            />
          );
        }

        const { source, route } = routeOrErr;
        return (
          <Fragment key={`${source}+${route.id}`}>
            <Link className="a" to={`/routes/${route.id}`} state={{ from: location }}>
              {route.name}
            </Link>{' '}
            <TagLinkWithParens tagName={source} />
            {idx < hostRoutes.length - 1 ? ', ' : null}
          </Fragment>
        );
      })}
    />
  );
}
